import React from "react";
import Loader from "./Loader";
import dataHeader from "./data.json";
const URL = require("./constants");

const Header = () => {
	return (
		<>
			<Loader />
			<header id="site-header" className="header header-1">
				<div className="container-fluid">
					<div id="header-wrap" className="box-shadow">
						<div className="row">
							<div className="col-lg-12">
								{/* Navbar */}
								<nav className="navbar navbar-expand-lg">
									<a className="navbar-brand logo" href="/">
										<img
											id="logo-img"
											className="img-center"
											src={`${URL.img_url}${dataHeader.data.logo}`}
											alt=""
										/>
									</a>
									<button
										className="navbar-toggler"
										type="button"
										data-toggle="collapse"
										data-target="#navbarNavDropdown"
										aria-expanded="false"
										aria-label="Toggle navigation"
									>
										{" "}
										<span></span>
										<span></span>
										<span></span>
									</button>
									<div
										className="collapse navbar-collapse"
										id="navbarNavDropdown"
									>
										{/* Left nav */}
										<ul
											id="main-menu"
											className="nav navbar-nav ml-auto mr-auto"
										>
											<li className="nav-item">
												{" "}
												<a
													className="nav-link active"
													href="#"
												>
													Home
												</a>
												<ul>
													{dataHeader.data.home.map(
														(data, index) => (
															<li key={index}>
																<a
																	href={`/${data["link"]}`}
																>
																	{
																		data[
																			"title"
																		]
																	}
																</a>
															</li>
														)
													)}
												</ul>
											</li>
											<li className="nav-item">
												{" "}
												<a
													className="nav-link"
													href="#"
												>
													Pages
												</a>
												<ul>
													{dataHeader.data.pages.map(
														(data, index) => (
															<li key={index}>
																<a
																	href={`/${data["link"]}`}
																>
																	{
																		data[
																			"title"
																		]
																	}
																</a>
															</li>
														)
													)}

													<li>
														<a href="#">Element</a>
														<ul>
															{dataHeader.data.element.map(
																(
																	data,
																	index
																) => (
																	<li
																		key={
																			index
																		}
																	>
																		<a
																			href={`/${data["link"]}`}
																		>
																			{
																				data[
																					"title"
																				]
																			}
																		</a>
																	</li>
																)
															)}
														</ul>
													</li>
												</ul>
											</li>
											<li className="nav-item">
												<a
													className="nav-link"
													href="#"
												>
													About Us
												</a>
												<ul>
													{dataHeader.data.about.map(
														(data, index) => (
															<li key={index}>
																<a
																	href={`/${data["link"]}`}
																>
																	{
																		data[
																			"title"
																		]
																	}
																</a>
															</li>
														)
													)}
												</ul>
											</li>
											<li className="nav-item">
												{" "}
												<a
													className="nav-link"
													href="#"
												>
													Services
												</a>
												<ul>
													{dataHeader.data.services.map(
														(data, index) => (
															<li key={index}>
																<a
																	href={`/${data["link"]}`}
																>
																	{
																		data[
																			"title"
																		]
																	}
																</a>
															</li>
														)
													)}
												</ul>
											</li>
											<li className="nav-item">
												{" "}
												<a
													className="nav-link"
													href="#"
												>
													Blogs
												</a>
												<ul>
													{dataHeader.data.blogs.map(
														(data, index) => (
															<li key={index}>
																<a
																	href={`/${data["link"]}`}
																>
																	{
																		data[
																			"title"
																		]
																	}
																</a>
															</li>
														)
													)}
												</ul>
											</li>
											<li className="nav-item">
												{" "}
												<a
													className="nav-link"
													href="#"
												>
													Contact Us
												</a>
												<ul>
													{dataHeader.data.contact.map(
														(data, index) => (
															<li key={index}>
																<a
																	href={`/${data["link"]}`}
																>
																	{
																		data[
																			"title"
																		]
																	}
																</a>
															</li>
														)
													)}
												</ul>
											</li>
										</ul>
									</div>
									<a
										className="btn btn-theme btn-sm"
										href={`/${dataHeader.data.login.link}`}
										data-text="Login"
									>
										{" "}
										<span>L</span>
										<span>o</span>
										<span>g</span>
										<span>i</span>
										<span>n</span>
									</a>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
